import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, ArrowRight, RefreshCw } from "lucide-react";

export default function PaymentFailure() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <Card className="max-w-lg w-full card-soft" data-testid="payment-failure-card">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-[#EF4444] rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="font-serif text-3xl text-[#4A4036] mb-4">
            Pago no procesado
          </h1>
          
          <p className="text-lg text-[#786C60] mb-8">
            Hubo un problema al procesar tu pago. No te preocupes, no se realizó ningún cargo.
          </p>
          
          <div className="bg-[#FDFBF7] rounded-xl p-6 mb-8">
            <h3 className="font-semibold text-[#4A4036] mb-3">Posibles motivos:</h3>
            <ul className="text-left text-[#786C60] space-y-2">
              <li>• Fondos insuficientes en la tarjeta</li>
              <li>• Datos de la tarjeta incorrectos</li>
              <li>• Límite de compra excedido</li>
              <li>• Tarjeta vencida o bloqueada</li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <Link to="/#precios">
              <Button className="btn-primary w-full" data-testid="retry-payment-btn">
                <RefreshCw className="mr-2 w-5 h-5" />
                Intentar nuevamente
              </Button>
            </Link>
            
            <Link to="/">
              <Button variant="outline" className="btn-outline w-full" data-testid="back-home-btn">
                Volver al inicio
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
